"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = void 0;
var Color = /** @class */ (function () {
    function Color() {
        this.hue = 0;
        this.saturation = 0;
        this.lighteness = 0;
    }
    Color.prototype.darken = function (amount) {
        this.lighteness -= amount;
        return this;
    };
    Color.prototype.lighten = function (amount) {
        this.lighteness += amount;
        return this;
    };
    Color.prototype.asHsl = function () {
        return "hsl(".concat(this.hue, ", ").concat(this.saturation, "%, ").concat(this.lighteness, "%)");
    };
    Color.prototype.asHsla = function (alpha) {
        if (alpha === void 0) { alpha = 1; }
        return "hsla(".concat(this.hue, ", ").concat(this.saturation, "%, ").concat(this.lighteness, "%, ").concat(alpha, ")");
    };
    Color.fromRgb = function (red, green, blue) {
        (red /= 255), (green /= 255), (blue /= 255);
        var max = Math.max(red, green, blue), min = Math.min(red, green, blue);
        var hue, saturation, lightness = (max + min) / 2;
        if (max === min) {
            hue = saturation = 0;
        }
        else {
            var d = max - min;
            saturation = lightness > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case red:
                    hue = (green - blue) / d + (green < blue ? 6 : 0);
                    break;
                case green:
                    hue = (blue - red) / d + 2;
                    break;
                case blue:
                    hue = (red - green) / d + 4;
                    break;
            }
            hue /= 6;
        }
        saturation = Math.round(saturation * 100);
        lightness = Math.round(lightness * 100);
        hue = Math.round(360 * hue);
        var color = new Color();
        color.hue = hue;
        color.saturation = saturation;
        color.lighteness = lightness;
        return color;
    };
    Color.fromHex = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var red = parseInt(result[1], 16);
        var green = parseInt(result[2], 16);
        var blue = parseInt(result[3], 16);
        return Color.fromRgb(red, green, blue);
    };
    return Color;
}());
exports.Color = Color;
exports.default = Color;
//# sourceMappingURL=color.js.map